module.exports = __webpack_public_path__ + "img/60m9.a8f0848a.jpg";